import React from "react";
import { FaExclamationTriangle, FaSpinner } from "react-icons/fa";
import SimpleModal from "../../SimpleModal";
import pwPrefiller from "../Shared/pwPrefiller";

export function AcknowledgePage({
  formType, // new field
  toggleModalSequence,
  page,
  setPage,
  resetState,
  formVersion,
  prefillLoading,
  selectedCase,
  selectedCaseData,
  setPrefillLoading, // new field
  addPW,
  formApi, // new field
  setAcknowledgementData, // new field
}) {
  const defaultDisclaimer = `Modifying fields imported from your Prevailing Wage Determination 
  may lead to delays in processing your application.`;
  return (
    <SimpleModal
      toggleModal={toggleModalSequence}
      modalStatus={page === 2}
      renderButton={() => null}
      minWidth="40%"
      onRequestClose={() => resetState()}
    >
      <>
        <div className="pwd-disclaimer-body">
          <p className="modal-centered-icon pwd-disclaimer-icon">
            <FaExclamationTriangle color={"#e9e9e9"} size={"2em"} />
          </p>
          <p className="pwd-disclaimer-text">
            {formType === "9089" ? (
              <ol>
                <li>
                  You have permission from the Employer POC to link the selected
                  PWD.
                </li>
                <li>{defaultDisclaimer}</li>
              </ol>
            ) : (
              defaultDisclaimer
            )}
          </p>
        </div>

        <div>
          <button
            type="button"
            style={{ marginTop: "15px", float: "left" }}
            className={"usa-button usa-button--outline"}
            onClick={() => setPage(formVersion === 1 ? 1 : 0)}
          >
            Back
          </button>
          <button
            type={"button"}
            className={"usa-button usa-button-primary modal-submit"}
            onClick={() => {
              // 9089 needs counties passed in
              pwPrefiller({
                formType,
                data: selectedCaseData,
                selectedCaseData,
                setPrefillLoading,
                formApi,
              }).then((result) => {
                if (result && result.length > 0) {
                  resetState();
                }
              });
              addPW(selectedCase, selectedCaseData);

              if (setAcknowledgementData) {
                setAcknowledgementData();
              }
            }}
          >
            Acknowledge &amp; Finish{" "}
            <FaSpinner
              style={{
                width: "10px",
                height: "10px",
                marginleft: "8px",
                transition: "width 400ms ease-in-out",
                WebkitTransition: "width 400ms ease-in-out",
                MozTransition: "width 400ms ease-in-out",
              }}
              className={prefillLoading ? "icon-spin" : "hidden"}
            />
          </button>
        </div>
      </>
    </SimpleModal>
  );
}
